export default __webpack_public_path__ + "static/media/V_wdt_c_cap_1.d89217e1.mp3";